module.exports = __webpack_public_path__ + "img/8环境管理体系认证证书.eb9134d5.jpg";